import { Icon } from 'vant';
import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";

import 'normalize.css/normalize.css';
import 'vant/lib/index.css';

import VConsole from 'vconsole';
const _vconsole = new URL(window.location.href).search.includes('vconsole=1')
if(process.env.VUE_APP_VCONSOLE == 'true' || _vconsole) var vConsole = new VConsole();

const app = createApp(App)
app.use(router)
app.use(store)
app.use(Icon);

app.mount('#app')